import isEqual from 'lodash/isEqual';
import difference from 'lodash/difference';
import { findLabelByLng } from '@yesplz/core';
import Widget from '../modules/Widget';
import isParamsMatchPreset from '../helpers/isParamsMatchPreset';
import { FABRIC_COLORS, COLOR_LABELS } from '../consts';

import clearSvg from '@yesplz/core-models/assets/svg/reset-icon.svg';
import EventEmitter from '../modules/EventEmitter';

class ColorFilter extends Widget {
  defaultParams = {
    resetImage: clearSvg,
    displayLabels: false,
  };

  constructor(params) {
    super(params);

    this.element = document.createElement('div');
    this.element.className = 'ColorPallete';
    this.colorElements = {};

    this.params.colors = {
      ...(this.params.colors ?? FABRIC_COLORS),
      clear: '',
    };
  }

  didMount() {
    this.updateColors();
  }

  didUpdate(prevState) {
    if (
      !isEqual(
        prevState.search?.filters?.colors,
        this.state.search?.filters?.colors
      )
    ) {
      this.updateColors();
    }
    else if (
      !isEqual(prevState.filter.params.color, this.state.filter.params.color)
    ) {
      const prevColor = prevState.filter.params.color;
      const color = this.state.filter.params.color;
      const addedItems = difference(color, prevColor);
      const removedItems = difference(prevColor, color);
      addedItems.forEach(val => this.colorElements[val].classList.add('active'));
      removedItems.forEach(val => this.colorElements[val].classList.remove('active'));
    }
  }

  handleLabelClick = (colorName) => {
    const { categoryId, params } = this.state.filter;

    EventEmitter.emit('colorThumbnailClick', {
      categoryId,
      color: colorName,
    });

    let color = params.color || [];

    if (colorName === 'clear') {
      color = [];
    }
    else {
      color = (
        color.includes(colorName)
          ? color.filter(color => color !== colorName)
          : [...color, colorName]
      );
    }

    const newParams = {
      ...params,
      color,
    };
    
    const currentPresetIndex = this.state.filter.presetIndex;
    let presetIndex = null;
    if (currentPresetIndex) {
      const preset = this.main.categories[this.state.filter.categoryId].presetsList[currentPresetIndex];
      if (preset && isParamsMatchPreset(newParams, preset)) {
        presetIndex = currentPresetIndex;
      }
    }

    this.setFilter({
      presetIndex,
      params: newParams,
    });
  }

  updateColors() {
    const { colors: availableColors } = this.state.search?.filters || {};

    for (const colorName in this.params.colors) {
      const isAvailable = !availableColors || !!(availableColors[colorName] && availableColors[colorName].isActive) || colorName === 'clear';
      if (!isAvailable) {
        this.colorElements[colorName].classList.add('disabled');
      }
      else {
        this.colorElements[colorName].classList.remove('disabled');
      }
    }

    if (typeof this.params.onUpdated === 'function') {
      this.params.onUpdated(Object.values(availableColors || {}));
    }
  }

  renderColors() {
    const { params } = this.state.filter;
    const { lng } = this.state.config;
    this.element.innerHTML = '';
    this.colorElements = {};
    const colorButtons = this.params.colors;
    for (const colorName in colorButtons) {
      const color = this.params.colors[colorName];
      const labelElement = document.createElement('button');
      const isActive = params.color && params.color.includes(colorName);

      if (colorName === 'clear') {
        labelElement.innerHTML = `<div class="ColorButton-color-wrapper">
          <img src="${this.params.resetImage}" alt="" />
        </div>
        ${this.params.displayLabels ? `<span>${findLabelByLng(COLOR_LABELS['all'], lng)}</span>` : ''}`;
      }
      else {
        const styleProp = `style="background-${color[0] !== '#' ? 'image' : 'color'}: ${color};"`;
        labelElement.innerHTML =
          `
          <div class="ColorButton-color-wrapper">
            <div
              class="ColorButton-color"
              ${styleProp}
            ></div>
            <div class="ColorButton-mask"></div>
          </div>
          ${this.params.displayLabels ? '<span>' + findLabelByLng(COLOR_LABELS[colorName] ? COLOR_LABELS[colorName] : colorName, lng) + '</span>' : ''}
          `;
      }

      labelElement.className = 'ColorButton ColorButton-' + colorName + (
        isActive ? ' active' : ''
      );

      this.colorElements[colorName] = labelElement;
      const wrapperElement = document.createElement('div');
      wrapperElement.appendChild(labelElement);
      wrapperElement.classList.add('ColorButton-wrapper');
      this.element.appendChild(wrapperElement);
      labelElement.addEventListener('click', () => {
        this.handleLabelClick(colorName);
      });
    }
  }

  render() {
    const container = document.createElement('div');
    const title = document.createElement('h3');
    title.innerText = this.params.title ? this.params.title : 'Colors';
    container.appendChild(title);
    this.renderColors();
    container.appendChild(this.element);
    return container;
  }
}

export default (params) => {
  return new ColorFilter(params);
};
